import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebaseConfig";
import "./PostShow.css"; // Ensure proper styling
import { Button } from "react-bootstrap";

function PostShow() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    const fetchPosts = async () => {
      const querySnapshot = await getDocs(collection(db, "posts"));
      setPosts(querySnapshot.docs.map(doc => ({ ...doc.data(), id: doc.id })));
    };
    fetchPosts();
  }, []);

  // Helper function to strip HTML tags and limit the length of the text
  const stripHtmlAndTruncate = (html, limit) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    const textContent = tempDiv.textContent || tempDiv.innerText || "";
    const words = textContent.split(" ");
    return words.length > limit ? words.slice(0, limit).join(" ") + "..." : textContent;
  };

  return (
    <div className="posts">
      {posts.map(post => (
        <div key={post.id} className="post">
          <h2>
            <Link to={`/post/${post.id}`}>{post.title}</Link>
          </h2>
          {post.imageUrl && <img src={post.imageUrl} alt={post.title} className="post-image" />}
          <div className="post-content">
            <div
              dangerouslySetInnerHTML={{ __html: stripHtmlAndTruncate(post.content, 30) }}
            />
          </div>
          <p><strong>Author:</strong> {post.author}</p>
          <p>
            <strong>Tags:</strong>{" "}
            {post.tags ? (
              post.tags.map((tag, index) => (
                <span key={index}>
                  <Link to={`/tags/${tag}`}>{tag}</Link>
                  {index !== post.tags.length - 1 && ", "}
                </span>
              ))
            ) : (
              "No tags"
            )}
          </p>
          <div className="read-more-button">
            <Link to={`/post/${post.id}`}>
              <Button variant="primary">Read More</Button>
            </Link>
          </div>
        </div>
      ))}
    </div>
  );
}

export default PostShow;
